import { createAppEndpoint } from "./app.utils";

export const APP_METHODS = {
  ACCOUNT_MANAGER: "accountManager",
  EMS: "Ems",
  BILLING: "billing",
  BUDGET: "budget",
  OSOS: "osos",
  USER_MANAGER: "userManager",
  SUSTAINABILITY: "sustainability",
  NOTIFICATION: "notification",
  POWER_PLANT: "powerPlant",
} as const;

export const APP_ENDPOINTS = {
  ACCOUNT_MANAGER: {
    GET_ACCOUNT_STATE: createAppEndpoint("getAccountState", APP_METHODS.ACCOUNT_MANAGER),
    GET_STORE: createAppEndpoint("getStore", APP_METHODS.ACCOUNT_MANAGER),
    SET_STORE: createAppEndpoint("setStore", APP_METHODS.ACCOUNT_MANAGER),
  },
  EMS: {
    GET_DEVICE_LIST_VIEW: createAppEndpoint("getDeviceListView", APP_METHODS.EMS),
    EXECUTE_DEVICE_COMMAND: createAppEndpoint("executeDeviceCommand", APP_METHODS.EMS),
    COMPARE_SENSORS: createAppEndpoint("compareMachines", APP_METHODS.EMS),
    GET_SENSOR_COMPARE_FILTERS: createAppEndpoint("getMachineCompareFilters", APP_METHODS.EMS),
    GET_DEVICE_GRAPHS: createAppEndpoint("getDeviceGraphs", APP_METHODS.EMS),
    GET_ACTIVE_ALARMS_TABLE: createAppEndpoint("getActiveAlarmsTable", APP_METHODS.EMS),
    GET_PAST_ALARMS_TABLE: createAppEndpoint("getPastAlarmsTable", APP_METHODS.EMS),
    GET_DEFINED_ALARMS_TABLE: createAppEndpoint("getDefinedAlarmsTable", APP_METHODS.EMS),
    PAUSE_ALERT_NOTIFICATIONS: createAppEndpoint("pauseAlertNotifications", APP_METHODS.EMS),
    RESUME_ALERT_NOTIFICATIONS: createAppEndpoint("resumeAlertNotifications", APP_METHODS.EMS),
    GET_ALARM: createAppEndpoint("getAlarm", APP_METHODS.EMS),
    GET_ALARM_OPTIONS: createAppEndpoint("getAlarmOptions", APP_METHODS.EMS),
    UPDATE_ALARM: createAppEndpoint("updateAlarm", APP_METHODS.EMS),
    CREATE_ALARM: createAppEndpoint("createAlarm", APP_METHODS.EMS),
    UPDATE_ALARM_DESCRIPTION: createAppEndpoint("updateAlarmDescription", APP_METHODS.EMS),
    UPDATE_ALARM_STATE: createAppEndpoint("updateAlarmState", APP_METHODS.EMS),
    DELETE_ALARM: createAppEndpoint("deleteAlarm", APP_METHODS.EMS),
  },
  BUDGET: {
    GET_BUDGET: createAppEndpoint("getBudget", APP_METHODS.BUDGET),
    GET_BUDGET_PLANNING: createAppEndpoint("getBudgetPlanning", APP_METHODS.BUDGET),
    GET_BUDGET_COMPARISON: createAppEndpoint("getBudgetComparison", APP_METHODS.BUDGET),
    GET_BUDGET_EXCEL_TEMPLATE: createAppEndpoint("getBudgetExcelTemplate", APP_METHODS.BUDGET),
    GET_BUDGET_EXCEL_UPLOAD_URL: createAppEndpoint("getBudgetExcelUploadURL", APP_METHODS.BUDGET),
    GET_BUDGET_CONTRACT_CONTEXTS: createAppEndpoint("getContractContexts", APP_METHODS.BUDGET),
    UPDATE_BUDGET: createAppEndpoint("updateBudget", APP_METHODS.BUDGET),
    PROCESS_BUDGET_EXCEL: createAppEndpoint("processBudgetExcel", APP_METHODS.BUDGET),
  },
  BILLING: {
    GET_DASHBOARD_INSTALLATION_LIST: createAppEndpoint("getDashboardInstallationList", APP_METHODS.BILLING),
    GET_DASHBOARD_CONSUMPTION_SUMMARY: createAppEndpoint("getDashboardConsumptionSummary", APP_METHODS.BILLING),
    GET_DASHBOARD_GENERATION_SUMMARY: createAppEndpoint("getDashboardGenerationSummary", APP_METHODS.BILLING),
    GET_DASHBOARD_BILLING_SUMMARY: createAppEndpoint("getDashboardBillingSummary", APP_METHODS.BILLING),
    GET_DASHBOARD_FINES: createAppEndpoint("getDashboardFines", APP_METHODS.BILLING),
    GET_DASHBOARD_SUMMARY_GRAPH: createAppEndpoint("getDashboardSummaryGraph", APP_METHODS.BILLING),
    GET_DASHBOARD_CAPACITIVE_FINES_TABLE_VALUES: createAppEndpoint("getDashboardCapacitiveFinesTableValues", APP_METHODS.BILLING),
    GET_DASHBOARD_INDUCTIVE_FINES_TABLE_VALUES: createAppEndpoint("getDashboardInductiveFinesTableValues", APP_METHODS.BILLING),
    GET_DASHBOARD_MAX_DEMAND_FINES_TABLE_VALUES: createAppEndpoint("getDashboardMaxDemandFinesTableValues", APP_METHODS.BILLING),
    GET_DASHBOARD_MISSED_ADVANTAGE_TABLE: createAppEndpoint("getDashboardMissedAdvantageTable", APP_METHODS.BILLING),
    GET_DASHBOARD_MISSED_ADVANTAGE_SINGLE: createAppEndpoint("getDashboardMissedAdvantageSingle", APP_METHODS.BILLING),
    GET_INSTALLATION_LIST: createAppEndpoint("getInstallationList", APP_METHODS.BILLING),
    GET_CONTEXT_TOTAL_CARDS: createAppEndpoint("getContextTotalCards", APP_METHODS.BILLING),
    GET_CONTEXT_BILL_UNIT_PRICES_GRAPH: createAppEndpoint("getContextBillUnitPricesGraph", APP_METHODS.BILLING),
    GET_CONTEXT_BILLS_TABLE: createAppEndpoint("getContextBillsTable", APP_METHODS.BILLING),
    GET_CONTEXT_BILLS_GRAPH: createAppEndpoint("getContextBillsGraph", APP_METHODS.BILLING),
    GET_CONTEXT_BILL_INFORMATION: createAppEndpoint("getContextBillInformations", APP_METHODS.BILLING),
    GET_CONTEXT_BILL_DETAILS_GRAPH: createAppEndpoint("getContextBillDetailsGraph", APP_METHODS.BILLING),
    UPDATE_BILLING: createAppEndpoint("updateContextWithContract", APP_METHODS.BILLING),
    GET_CONTRACT: createAppEndpoint("getContract", APP_METHODS.BILLING),
    GET_DISTRIBUTION_COMPANIES: createAppEndpoint("getDistributionCompanies", APP_METHODS.BILLING),
    GET_ONBOARDING_DATA: createAppEndpoint("getOnboardingData", APP_METHODS.BILLING),
    VERIFY_BILLING: createAppEndpoint("verifyBill", APP_METHODS.BILLING),
    GET_TARIFFS: createAppEndpoint("getTariffAnalysisSingle", APP_METHODS.BILLING),
    GET_BILL_CALCULATION_EXCEL_URL: createAppEndpoint("getBillCalculationExcelURL", APP_METHODS.BILLING),
    GET_ALL_CONTRACTS: createAppEndpoint("getAllContractsTable", APP_METHODS.BILLING),
    CREATE_CONTEXT_WITH_CONTRACT: createAppEndpoint("createContextWithContract", APP_METHODS.BILLING),
    DELETE_CONTRACT_CONTEXT: createAppEndpoint("deleteContractContext", APP_METHODS.BILLING),
    GET_BILLING_CONTRACT_CONTEXTS: createAppEndpoint("getContractContexts", APP_METHODS.BILLING),
    GET_PREDICTION_CHART: createAppEndpoint("getPredictionChart", APP_METHODS.BILLING),
    GET_PREDICTION_DAILY_AVERAGE_CARD: createAppEndpoint("getPredictionDailyAverageCard", APP_METHODS.BILLING),
    GET_PREDICTION_REAL_BILL_CARD: createAppEndpoint("getPredictionRealBillCard", APP_METHODS.BILLING),
    GET_PREDICTION_SUM_CARD: createAppEndpoint("getPredictionSumCard", APP_METHODS.BILLING),
    GET_PREDICTION_ACCURACY_CARD: createAppEndpoint("getPredictionAccuracyCard", APP_METHODS.BILLING),
    GET_AUDIT_TABLE: createAppEndpoint("getAuditTable", APP_METHODS.BILLING),
    GET_MCP_REAL_AVERAGE_CARD: createAppEndpoint("getMcpRealAverageCard", APP_METHODS.BILLING),
    GET_MCP_WEIGHTED_AVERAGE_CARD: createAppEndpoint("getMcpWeightedAverageCard", APP_METHODS.BILLING),
    GET_MCP_PREDICTED_AVERAGE_CARD: createAppEndpoint("getMcpPredictedAverageCard", APP_METHODS.BILLING),
    GET_MCP_RATIO_CARD: createAppEndpoint("getMcpRatioCard", APP_METHODS.BILLING),
    GET_MCP_PREDICTED_HEATMAP_CHART: createAppEndpoint("getMcpPredictedHeatmapChart", APP_METHODS.BILLING),
    GET_MCP_HOURLY_AVERAGE_CHART: createAppEndpoint("getMcpHourlyAverageChart", APP_METHODS.BILLING),
    GET_MCP_DAILY_AVERAGE_CHART: createAppEndpoint("getMcpDailyAverageChart", APP_METHODS.BILLING),
    GET_MCP_MONTHLY_AVERAGE_CHART: createAppEndpoint("getMcpMonthlyAverageChart", APP_METHODS.BILLING),
  },
  OSOS: {
    GET_OSOS_TABLE: createAppEndpoint("getOsosTablePaginated", APP_METHODS.OSOS),
    GET_OSOS: createAppEndpoint("getOsos", APP_METHODS.OSOS),
    GET_OSOS_DETAILS: createAppEndpoint("getOsosDetails", APP_METHODS.OSOS),
    GET_OSOS_LIST: createAppEndpoint("getOsosListTable", APP_METHODS.OSOS),
    TRIGGER_DATA_PULL: createAppEndpoint("triggerDataPull", APP_METHODS.OSOS),
    CREATE_OSOS: createAppEndpoint("createOsos", APP_METHODS.OSOS),
    DELETE_OSOS: createAppEndpoint("deleteOsos", APP_METHODS.OSOS),
    UPDATE_OSOS: createAppEndpoint("updateOsos", APP_METHODS.OSOS),
  },
  USER_MANAGER: {
    GET_USERS_TABLE: createAppEndpoint("getUsersTable", APP_METHODS.USER_MANAGER),
    GET_USER: createAppEndpoint("getUser", APP_METHODS.USER_MANAGER),
    GET_USERS: createAppEndpoint("getUsers", APP_METHODS.USER_MANAGER),
    CREATE_USER: createAppEndpoint("addUser", APP_METHODS.USER_MANAGER),
    UPDATE_USER: createAppEndpoint("updateUser", APP_METHODS.USER_MANAGER),
    DELETE_USER: createAppEndpoint("deleteUser", APP_METHODS.USER_MANAGER),
    RESEND_USER_INVITATION: createAppEndpoint("resendUserInvitation", APP_METHODS.USER_MANAGER),
  },
  SUSTAINABILITY: {
    GET_CONSUMPTION_CARDS: createAppEndpoint("getConsumptionCards", APP_METHODS.SUSTAINABILITY),
    GET_CONSUMPTION_COMPARISON: createAppEndpoint("getConsumptionComparison", APP_METHODS.SUSTAINABILITY),
    GET_CONSUMPTION_EMISSION: createAppEndpoint("getConsumptionEmission", APP_METHODS.SUSTAINABILITY),
    GET_CONSUMPTION_TREES: createAppEndpoint("getConsumptionTrees", APP_METHODS.SUSTAINABILITY),
    GET_GENERATION_CARDS: createAppEndpoint("getGenerationCards", APP_METHODS.SUSTAINABILITY),
    GET_GENERATION_COMPARISON: createAppEndpoint("getGenerationComparison", APP_METHODS.SUSTAINABILITY),
    GET_GENERATION_EMISSION: createAppEndpoint("getGenerationEmission", APP_METHODS.SUSTAINABILITY),
    GET_GENERATION_TREES: createAppEndpoint("getGenerationTrees", APP_METHODS.SUSTAINABILITY),
    GET_EMISSION_DASHBOARD: createAppEndpoint("getEmissionDashboard", APP_METHODS.SUSTAINABILITY),
    GET_TREES_DASHBOARD: createAppEndpoint("getTreesDashboard", APP_METHODS.SUSTAINABILITY),
  },
  POWER_PLANT: {
    GET_POWER_STATIONS_TABLE: createAppEndpoint("getPowerStationsTable", APP_METHODS.POWER_PLANT),
    GET_POWER_STATIONS_CARDS: createAppEndpoint("getPowerStationsCards", APP_METHODS.POWER_PLANT),
    GET_POWER_STATIONS_MAP: createAppEndpoint("getPowerStationsMapData", APP_METHODS.POWER_PLANT),
    GET_POWER_STATION_DETAILS: createAppEndpoint("getPowerStationDetails", APP_METHODS.POWER_PLANT),
  },
  NOTIFICATIONS: {
    GET_IN_APP_NOTIFICATIONS: createAppEndpoint("getInAppNotifications", APP_METHODS.NOTIFICATION),
    SET_IN_APP_NOTIFICATION_SEEN: createAppEndpoint("setInAppNotificationSeen", APP_METHODS.NOTIFICATION),
    DELETE_IN_APP_NOTIFICATION: createAppEndpoint("deleteInAppNotification", APP_METHODS.NOTIFICATION),
  },
} as const;
